import { IEvent, IEventImage, IEventProperties } from "../interfaces/map.interfaces";
import { env } from "../env";
import * as ROUTES from "../constants/routes";

export const STATION_GALLERY_STORAGE_KEY = "svs-station-gallery-event";

export const STATION_EVENT_TYPE = "Station";
export const HAN_PROJECT_ID = "han";

export const isHanProject = (projectId?: string): boolean =>
  projectId === HAN_PROJECT_ID;

export const canShowStations = (): boolean =>
  !!(window as any)._userData?.show_stations;

export const isStationEvent = (properties?: Partial<IEventProperties>): boolean =>
  properties?.type === STATION_EVENT_TYPE ||
  (properties?.id != null && properties.id.includes("_sta_"));

export const PLANET_STATION_LOCATION_PREFIXES = [
  "han_len_sta_",
  "han_tra_sta_",
  "han_bue_sta_",
  "han_kri_sta_",
  "han_spo_sta_",
];

export const hasPlanetImagery = (
  properties?: Partial<IEventProperties>
): boolean =>
  [properties?.locationId, properties?.id].some(
    (id) =>
      id != null &&
      PLANET_STATION_LOCATION_PREFIXES.some((prefix) => id.startsWith(prefix))
  );

export const getHanEventTypes = (types?: string[]): string[] => {
  const base = types ? [...types] : [];
  if (!base.includes(STATION_EVENT_TYPE)) {
    base.push(STATION_EVENT_TYPE);
  }
  return base;
};

export const getStationImageUploadKey = (
  newEventId: string,
  existingImages: IEventImage[] = []
): string => {
  if (existingImages.length === 0) {
    return `${newEventId}.png`;
  }
  return `${newEventId}.png`;
};

export const buildStationImageEntry = (
  key: string,
  date: string,
  name: string,
  author?: string
): IEventImage => ({
  key,
  date,
  name,
  author,
});

export const getStationImagesUrl = (eventId: string): string => {
  const prefix = env.REACT_APP_GIS_PREFIX || "";
  return `${prefix}${ROUTES.STATION_IMAGES.route}?eventId=${encodeURIComponent(
    eventId
  )}`;
};

export const storeStationGalleryEvent = (event: IEvent): void => {
  try {
    localStorage.setItem(STATION_GALLERY_STORAGE_KEY, JSON.stringify(event));
  } catch {
    // ignore quota / private-mode failures; the new tab can still fetch
  }
};

export const readStationGalleryEvent = (eventId?: string | null): IEvent | null => {
  if (!eventId) {
    return null;
  }
  try {
    const raw = localStorage.getItem(STATION_GALLERY_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as IEvent;
    if (parsed?.properties?.id !== eventId) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
};
